export default __webpack_public_path__ + "static/media/fr4.8af2a2c1.webp";